import type { SVGProps } from "react";
export default function SvgSearch(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-search-icon lucide-search"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="m21 21-4.34-4.34" />
			<circle cx={11} cy={11} r={8} />
		</svg>
	);
}
